import objectHash from 'object-hash';
import { Fragment, useContext, useEffect, useRef } from 'react';

import type { ContentfulData } from '@/integrations/contentful';
import { generateSectionKey } from '@/integrations/contentful';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import type { StrapMaterialSectionOpts } from './cms';
import { renderContentfulCollectionSection } from './cms';

export const usePreRenderCmsSections = (
  cmsData: ContentfulData[],
  pageName: string,
) => {
  const draftMode = useContext(DraftModeContext);
  const cmsContentMap = useRef(new Map());

  useEffect(() => {
    return () => {
      cmsContentMap.current.clear();
    };
  }, []);

  const sectionsOpts: StrapMaterialSectionOpts = [
    {
      type: 'Placeholder',
      opts: {
        type: 'product listing',
      },
    },
    {
      type: 'HeroProductListing',
      opts: {
        type: 'strap material',
        pageName: pageName,
      },
    },
  ];

  const buildCms = (data: ContentfulData, i: number) => {
    const hash = objectHash(data);
    let el = cmsContentMap.current.get(hash);

    if (el) {
      return el;
    }
    el = (
      <Fragment key={generateSectionKey(data, i)}>
        {renderContentfulCollectionSection(
          data,
          sectionsOpts,
          undefined,
          draftMode,
        )}
      </Fragment>
    );
    cmsContentMap.current.set(hash, el);
    return el;
  };

  const cmsSectionAll = cmsData.map(buildCms);

  return { cmsSectionAll };
};
